/* ==========================================================================
   Snushus Web-App (Home-Bildschirm)
   - Zurück-Taste im Header
   - Tab-Bar: Suche und Mini-Warenkorb von Warehouse öffnen, Zähler synchronisieren
   - Hinweis "Zum Home-Bildschirm" in Safari auf dem iPhone
   ========================================================================== */
(function () {
  'use strict';

  var root = document.documentElement;

  function isWebapp() {
    return root.classList.contains('is-webapp');
  }

  /* ------------------------------------------------------------------------
     In der App: Nach "In den Warenkorb" den Mini-Warenkorb nicht öffnen.
     Warehouse liest die Warenkorb-Art aus window.theme.cartType. "message" zeigt nur
     eine kurze Bestätigung, der Zähler in Header und Tab-Bar wird trotzdem aktualisiert.
     Dieses Script läuft vor theme.js, deshalb greift die Änderung rechtzeitig.
     ------------------------------------------------------------------------ */
  if (isWebapp() && window.theme && window.theme.cartType === 'drawer') {
    window.theme.cartType = 'message';
  }

  function homeUrl() {
    return (window.routes && window.routes.rootUrl) || '/';
  }

  /* ------------------------------------------------------------------------
     Zurück-Taste
     ------------------------------------------------------------------------ */
  document.addEventListener('click', function (event) {
    var back = event.target.closest('[data-webapp-back]');
    if (!back) return;

    event.preventDefault();

    var cameFromShop = false;
    try {
      cameFromShop = !!document.referrer && new URL(document.referrer).origin === window.location.origin;
    } catch (e) {}

    if (cameFromShop && window.history.length > 1) {
      window.history.back();
    } else {
      window.location.href = homeUrl();
    }
  });

  /* ------------------------------------------------------------------------
     Tab-Bar
     ------------------------------------------------------------------------ */
  // Mini-Warenkorb und Suche berechnen ihre Höhe ab dem Header. Steht oben auf der
  // Seite noch die Trustpilot-Leiste darüber, ragt das Panel unten aus dem Bildschirm.
  // Deshalb vor dem Öffnen so weit scrollen, dass der Header oben angedockt ist.
  function dockHeader() {
    var section = document.querySelector('.shopify-section__header');
    if (!section) return;

    var safeTop = parseFloat(window.getComputedStyle(document.body).paddingTop) || 0;
    var offset = section.getBoundingClientRect().top - safeTop;

    if (offset > 1) {
      window.scrollBy(0, offset);
    }
  }

  function initTabbar() {
    var tabbar = document.querySelector('.webapp-tabbar');
    if (!tabbar) return;

    // Listener auf der Tab-Bar selbst: so erreicht der ursprüngliche Klick die
    // "Klick ausserhalb schliesst"-Logik von Warehouse nicht und das geöffnete
    // Panel bleibt offen. Alles synchron, damit iOS bei der Suche die Tastatur öffnet.
    tabbar.addEventListener('click', function (event) {
      var tab = event.target.closest('[data-webapp-tab]');
      if (!tab) return;

      var action = tab.getAttribute('data-webapp-tab');

      if (action === 'search') {
        var searchToggle = document.querySelector('.header [data-action="toggle-search"]');
        var searchInput = document.querySelector('.header .search-bar__input');

        if (searchToggle) {
          event.preventDefault();
          event.stopPropagation();
          dockHeader();
          searchToggle.click();
        } else if (searchInput) {
          event.preventDefault();
          event.stopPropagation();
          window.scrollTo(0, 0);
          searchInput.focus();
        }
        return;
      }

      if (action === 'cart') {
        var cartToggle = document.querySelector('.header__cart-toggle[data-action="toggle-mini-cart"]');

        if (cartToggle) {
          event.preventDefault();
          event.stopPropagation();
          dockHeader();
          cartToggle.click();
        }
        return;
      }

      // Aktiven Tab nochmals antippen: nach oben scrollen (wie in nativen Apps)
      if (tab.classList.contains('is-active') && tab.pathname === window.location.pathname) {
        event.preventDefault();
        window.scrollTo({ top: 0, behavior: 'smooth' });
        return;
      }

      // Neuen Tab sofort als aktiv markieren, nicht erst wenn die nächste Seite geladen ist
      setActiveTab(tab);
    });

    var tabs = Array.prototype.slice.call(tabbar.querySelectorAll('[data-webapp-tab]'));
    var initialActive = tabbar.querySelector('.webapp-tabbar__item.is-active');

    function setActiveTab(activeTab) {
      tabs.forEach(function (item) {
        var isActive = item === activeTab;
        item.classList.toggle('is-active', isActive);
        if (isActive) {
          item.setAttribute('aria-current', 'page');
        } else {
          item.removeAttribute('aria-current');
        }
      });
    }

    // Mit "Zurück" aus dem Zwischenspeicher wiederhergestellte Seite: richtigen Tab wieder markieren
    window.addEventListener('pageshow', function (event) {
      if (event.persisted) setActiveTab(initialActive);
    });

    // Warenkorb-Zähler aus dem Header übernehmen, den Warehouse nach jedem
    // "In den Warenkorb" aktualisiert
    var badge = tabbar.querySelector('[data-webapp-cart-count]');
    var header = document.querySelector('.header');
    if (!badge || !header) return;

    var current = parseInt(badge.textContent, 10) || 0;

    function syncCount() {
      var source = header.querySelector('.header__cart-count');
      if (!source) return;

      var count = parseInt(source.textContent, 10) || 0;
      if (count === current) return;

      var increased = count > current;
      current = count;
      badge.textContent = count;
      badge.hidden = count === 0;

      if (increased) {
        badge.classList.remove('is-bumped');
        void badge.offsetWidth; // Animation neu starten
        badge.classList.add('is-bumped');
      }
    }

    new MutationObserver(syncCount).observe(header, {
      childList: true,
      characterData: true,
      subtree: true
    });

    syncCount();
  }

  /* ------------------------------------------------------------------------
     Hinweis "Zum Home-Bildschirm" (nur Safari auf dem iPhone)
     ------------------------------------------------------------------------ */
  /* ------------------------------------------------------------------------
     Tracking: Ereignisse an Shopify-Kundenereignisse senden.
     Ein Custom Pixel (Shopify-Admin → Einstellungen → Kundenereignisse) leitet sie an GA4 weiter.
     ------------------------------------------------------------------------ */
  function track(name, data) {
    var payload = data || {};
    payload.language = document.documentElement.lang || '';

    var attempts = 0;
    (function send() {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        try { window.Shopify.analytics.publish(name, payload); } catch (e) {}
        return;
      }
      // Shopify lädt seine Analytics-Schnittstelle asynchron: bis zu 15 Sekunden warten
      if (++attempts < 30) window.setTimeout(send, 500);
    })();
  }

  var FIRST_OPEN_KEY = 'snushus-webapp-first-open';
  var SESSION_OPEN_KEY = 'snushus-webapp-session-open';

  function trackAppUsage() {
    if (!root.classList.contains('is-webapp-standalone')) return;

    // Erstes Öffnen nach der Installation: Die Home-Bildschirm-App hat einen eigenen,
    // anfangs leeren Speicher, der Eintrag fehlt also genau einmal pro Installation.
    try {
      if (!localStorage.getItem(FIRST_OPEN_KEY)) {
        localStorage.setItem(FIRST_OPEN_KEY, String(Date.now()));
        track('webapp_first_open');
      }
    } catch (e) {}

    // Einmal pro App-Sitzung
    try {
      if (!sessionStorage.getItem(SESSION_OPEN_KEY)) {
        sessionStorage.setItem(SESSION_OPEN_KEY, '1');
        var template = document.body.className.match(/template-([\w-]+)/);
        track('webapp_open', { page_type: template ? template[1] : '' });
      }
    } catch (e) {}
  }

  var HINT_DISMISSED_KEY = 'snushus-webapp-hint-dismissed'; // localStorage: per X geschlossen
  var HINT_VIEWS_KEY = 'snushus-webapp-hint-views';         // sessionStorage: Seitenaufrufe
  var HINT_SHOWS_KEY = 'snushus-webapp-hint-shows';         // sessionStorage: wie oft gezeigt
  var HINT_NEXT_KEY = 'snushus-webapp-hint-next';           // sessionStorage: frühester nächster Zeitpunkt
  var HINT_PAUSE_DAYS = 30;
  var HINT_FIRST_DELAY = 2500;

  function initInstallHint() {
    var hint = document.getElementById('webapp-install');
    if (!hint || isWebapp()) return;

    // iPhone: nur Safari (andere Browser und In-App-Browser können nicht installieren).
    // Android: Chrome & Co. melden selbst, wann eine Installation möglich ist (beforeinstallprompt).
    var ua = window.navigator.userAgent;
    var isIphone = /iPhone|iPod/.test(ua);
    var isOtherBrowserOrInApp = /CriOS|FxiOS|EdgiOS|OPiOS|GSA|FBAN|FBAV|Instagram|Line\//.test(ua);
    var platform = null;

    if (isIphone && !isOtherBrowserOrInApp) platform = 'ios';
    else if (/Android/.test(ua)) platform = 'android';
    if (!platform) return;

    // Einstellungen aus dem Theme-Editor (Section "App-Navigation")
    var visibleMs = (parseInt(hint.getAttribute('data-visible-seconds'), 10) || 10) * 1000;
    var repeatMs = (parseInt(hint.getAttribute('data-repeat-seconds'), 10) || 90) * 1000;
    var maxShows = parseInt(hint.getAttribute('data-max-shows'), 10) || 2;

    var cta = hint.querySelector('[data-webapp-install-cta]');
    var hideTimer = null;
    var showTimer = null;

    if (platform === 'android') {
      hint.querySelector('[data-webapp-install-text="ios"]').hidden = true;
      hint.querySelector('[data-webapp-install-text="android"]').hidden = false;
      if (cta) cta.hidden = false;
    }

    function storageGet(store, key) {
      try { return parseInt(store.getItem(key), 10) || 0; } catch (e) { return 0; }
    }

    function storageSet(store, key, value) {
      try { store.setItem(key, String(value)); } catch (e) {}
    }

    function isDismissed() {
      return Date.now() - storageGet(localStorage, HINT_DISMISSED_KEY) < HINT_PAUSE_DAYS * 24 * 60 * 60 * 1000;
    }

    function canInstall() {
      return platform === 'ios' || !!window.snushusInstallPrompt;
    }

    function scheduleShow(delay) {
      window.clearTimeout(showTimer);
      showTimer = window.setTimeout(show, Math.max(0, delay));
    }

    function show() {
      if (isDismissed() || !canInstall()) return;

      var shows = storageGet(sessionStorage, HINT_SHOWS_KEY);
      if (shows >= maxShows) return;

      storageSet(sessionStorage, HINT_SHOWS_KEY, shows + 1);
      track('webapp_install_hint_shown', { show_number: shows + 1, platform: platform });
      // Gilt auch über Seitenwechsel: nächster Auftritt frühestens nach Anzeigedauer + Pause
      storageSet(sessionStorage, HINT_NEXT_KEY, Date.now() + visibleMs + repeatMs);

      hint.classList.add('is-entering');
      hint.hidden = false;
      root.classList.add('webapp-install-visible');

      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          hint.classList.remove('is-entering');
        });
      });

      window.clearTimeout(hideTimer);
      hideTimer = window.setTimeout(function () {
        hide();
        if (shows + 1 < maxShows) scheduleShow(repeatMs);
      }, visibleMs);
    }

    function hide() {
      window.clearTimeout(hideTimer);
      hint.classList.add('is-entering'); // gleiche Animation rückwärts
      root.classList.remove('webapp-install-visible');

      window.setTimeout(function () {
        hint.hidden = true;
      }, 300);
    }

    hint.addEventListener('click', function (event) {
      // Android: echtes Installations-Fenster öffnen
      if (event.target.closest('[data-webapp-install-cta]')) {
        var installPrompt = window.snushusInstallPrompt;

        window.clearTimeout(showTimer);
        hide();
        if (!installPrompt) return;

        window.snushusInstallPrompt = null; // Chrome erlaubt jedes Fenster nur einmal
        track('webapp_install_prompt_opened', { platform: platform });
        installPrompt.prompt();

        installPrompt.userChoice.then(function (choice) {
          track('webapp_install_prompt_result', { platform: platform, outcome: choice.outcome });
          if (choice.outcome !== 'accepted') {
            storageSet(localStorage, HINT_DISMISSED_KEY, Date.now());
          }
        }).catch(function () {});
        return;
      }

      if (event.target.closest('[data-webapp-install-close]')) {
        window.clearTimeout(showTimer);
        hide();
        storageSet(localStorage, HINT_DISMISSED_KEY, Date.now());
        track('webapp_install_hint_dismissed', { platform: platform });
      }
    });

    // Wurde die App auf anderem Weg installiert (z. B. Chrome-Menü), Hinweis sofort weg
    window.addEventListener('appinstalled', function () {
      window.clearTimeout(showTimer);
      hide();
    });

    if (isDismissed()) return;

    // Erst ab dem zweiten Seitenaufruf
    var views = storageGet(sessionStorage, HINT_VIEWS_KEY) + 1;
    storageSet(sessionStorage, HINT_VIEWS_KEY, views);
    if (views < 2) return;

    if (storageGet(sessionStorage, HINT_SHOWS_KEY) >= maxShows) return;

    function start() {
      var next = storageGet(sessionStorage, HINT_NEXT_KEY);
      scheduleShow(Math.max(HINT_FIRST_DELAY, next - Date.now()));
    }

    if (canInstall()) {
      start();
    } else {
      // Android meldet die Installierbarkeit oft erst, nachdem jemand eine Weile auf der Seite war
      document.addEventListener('snushus:installable', start, { once: true });
    }
  }

  // Echte Installationen (nur Android/Chrome meldet das), unabhängig vom Hinweis
  window.addEventListener('appinstalled', function () {
    track('webapp_installed', { platform: 'android' });
  });

  /* ------------------------------------------------------------------------
     Kurzmeldung (Toast), auch über einen Seitenwechsel hinweg
     ------------------------------------------------------------------------ */
  var TOAST_KEY = 'snushus-webapp-toast';

  function showToast(message, duration) {
    if (!message) return;

    var toast = document.createElement('div');
    toast.className = 'webapp-toast is-hidden';
    toast.setAttribute('role', 'status');
    toast.textContent = message;
    document.body.appendChild(toast);

    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        toast.classList.remove('is-hidden');
      });
    });

    window.setTimeout(function () {
      toast.classList.add('is-hidden');
      window.setTimeout(function () { toast.remove(); }, 400);
    }, duration || 5000);
  }

  function queueToast(message) {
    try { sessionStorage.setItem(TOAST_KEY, message); } catch (e) {}
  }

  function showQueuedToast() {
    try {
      var message = sessionStorage.getItem(TOAST_KEY);
      if (message) {
        sessionStorage.removeItem(TOAST_KEY);
        window.setTimeout(function () { showToast(message, 7000); }, 400);
      }
    } catch (e) {}
  }

  /* ------------------------------------------------------------------------
     Erneut bestellen (Konto, Bestelldetails, Startseite)
     Funktioniert in der App und im normalen Browser.
     ------------------------------------------------------------------------ */
  function cartAddUrl() {
    return ((window.routes && window.routes.cartAddUrl) || '/cart/add') + '.js';
  }

  function cartUrl() {
    return (window.routes && window.routes.cartUrl) || '/cart';
  }

  function addToCart(items) {
    return window.fetch(cartAddUrl(), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (response) {
      return response.ok;
    });
  }

  async function reorder(button) {
    if (button.classList.contains('is-loading')) return;

    var items = [];
    try { items = JSON.parse(button.getAttribute('data-reorder')) || []; } catch (e) {}

    var skipped = parseInt(button.getAttribute('data-reorder-skipped'), 10) || 0;

    if (!items.length) {
      showToast(button.getAttribute('data-msg-none'), 5000);
      return;
    }

    var label = button.querySelector('.webapp-reorder__button-label');
    var originalLabel = label ? label.textContent : '';

    button.classList.add('is-loading');
    button.setAttribute('aria-busy', 'true');
    if (label) label.textContent = button.getAttribute('data-msg-loading');

    var added = 0;

    try {
      // Erst alles auf einmal. Schlägt das fehl (z. B. ein Artikel hat zu wenig Lagerbestand),
      // Artikel einzeln hinzufügen, damit der Rest trotzdem im Warenkorb landet.
      if (await addToCart(items)) {
        added = items.length;
      } else {
        for (var i = 0; i < items.length; i++) {
          if (await addToCart([items[i]])) {
            added++;
          } else {
            skipped++;
          }
        }
      }
    } catch (e) {}

    if (added === 0) {
      button.classList.remove('is-loading');
      button.removeAttribute('aria-busy');
      if (label) label.textContent = originalLabel;
      showToast(button.getAttribute('data-msg-error'), 6000);
      return;
    }

    if (skipped > 0) {
      queueToast(button.getAttribute('data-msg-partial').replace('[n]', skipped));
    }

    window.location.href = cartUrl();
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-reorder]');
    if (!button) return;

    event.preventDefault();
    reorder(button);
  });

  /* ------------------------------------------------------------------------
     Pull-to-Refresh (nur in der installierten App, Safari hat es selbst)
     ------------------------------------------------------------------------ */
  function initPullToRefresh() {
    if (!root.classList.contains('is-webapp-standalone')) return;

    var THRESHOLD = 70;
    var MAX_PULL = 110;
    var SIZE = 40;

    var indicator = document.createElement('div');
    indicator.className = 'webapp-ptr';
    indicator.setAttribute('aria-hidden', 'true');
    indicator.innerHTML = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 12a8 8 0 1 1-2.34-5.66"/><path d="M20 4v5h-5"/></svg>';
    document.body.appendChild(indicator);

    var icon = indicator.querySelector('svg');
    var startX = 0;
    var startY = 0;
    var distance = 0;
    var top = 0;
    var tracking = false;
    var decided = false;

    function headerBottom() {
      var header = document.querySelector('.shopify-section__header');
      if (header) return header.getBoundingClientRect().bottom;
      return parseFloat(window.getComputedStyle(document.body).paddingTop) || 0;
    }

    function isBlocked(target) {
      if (window.scrollY > 0) return true;
      if (document.querySelector('.header [aria-expanded="true"]')) return true; // Menü, Suche oder Warenkorb offen
      if (target.closest('input, textarea, select, .webapp-tabbar, .webapp-install, [data-no-ptr]')) return true;
      return false;
    }

    function render() {
      indicator.classList.remove('is-releasing');
      indicator.style.top = top + 'px';
      indicator.style.transform = 'translateY(' + (distance - SIZE) + 'px)';
      indicator.style.opacity = String(Math.min(1, distance / 40));
      icon.style.transform = 'rotate(' + Math.round((distance / THRESHOLD) * 270) + 'deg)';
    }

    function release() {
      indicator.classList.add('is-releasing');
      indicator.style.transform = 'translateY(' + (-SIZE) + 'px)';
      indicator.style.opacity = '0';
      distance = 0;
    }

    document.addEventListener('touchstart', function (event) {
      tracking = false;
      if (event.touches.length !== 1 || isBlocked(event.target)) return;

      startX = event.touches[0].clientX;
      startY = event.touches[0].clientY;
      top = headerBottom();
      distance = 0;
      decided = false;
      tracking = true;
    }, { passive: true });

    document.addEventListener('touchmove', function (event) {
      if (!tracking) return;

      var dx = event.touches[0].clientX - startX;
      var dy = event.touches[0].clientY - startY;

      if (!decided) {
        if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
        decided = true;

        // Nur senkrecht nach unten ziehen zählt, seitliches Wischen (Slider) nicht
        if (dy <= 0 || Math.abs(dx) > Math.abs(dy) || window.scrollY > 0) {
          tracking = false;
          return;
        }
      }

      distance = Math.min(MAX_PULL, Math.max(0, dy) * 0.55);
      render();
    }, { passive: true });

    function onEnd() {
      if (!tracking) return;
      tracking = false;

      if (distance >= THRESHOLD) {
        indicator.classList.add('is-releasing', 'is-refreshing');
        indicator.style.transform = 'translateY(' + Math.round(THRESHOLD * 0.5) + 'px)';
        indicator.style.opacity = '1';
        window.setTimeout(function () { window.location.reload(); }, 150);
      } else {
        release();
      }
    }

    document.addEventListener('touchend', onEnd, { passive: true });
    document.addEventListener('touchcancel', onEnd, { passive: true });
  }

  function init() {
    initTabbar();
    initInstallHint();
    initPullToRefresh();
    showQueuedToast();
    trackAppUsage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
